import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_NOTE_LOAD_BY_ID,

    ACTION_NOTE_SAVE,

    ACTION_NOTE_CREATE,

    ACTION_NOTE_VALIDATE,

    INoteLoadByIdAction,
    INoteLoadFailureAction,
    INoteLoadSuccessAction,

    INoteSaveAction,
    INoteSaveSuccessAction,
    INoteSaveFailureAction,

    INoteCreateAction,
    INoteCreateSuccessAction,
    INoteCreateFailureAction,

    INoteValidateAction,
    INoteValidateSuccessAction,
    INoteValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/note";
import { notesApi } from "../services/notes";


export const
    getNoteByIdEpic = (action$): Observable<INoteLoadSuccessAction | INoteLoadFailureAction> => {
        return action$
            .ofType(ACTION_NOTE_LOAD_BY_ID)
            .mergeMap((action: INoteLoadByIdAction) => {
                return notesApi
                    .getNoteById(action.id)
                    .map(response =>
                        LoadSuccess(response.note, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setNoteEpic = (action$): Observable<INoteSaveSuccessAction | INoteSaveFailureAction> => {
        return action$
            .ofType(ACTION_NOTE_SAVE)
            .mergeMap((action: INoteSaveAction) => {
                return notesApi
                    .setNote(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.note, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createNoteEpic = (action$): Observable<INoteCreateSuccessAction | INoteCreateFailureAction> => {
        return action$
            .ofType(ACTION_NOTE_CREATE)
            .mergeMap((action: INoteCreateAction) => {
                return notesApi
                    .createNote(action.trialId, action.institutionId, action.trialInstitutionId, action.personnelId, action.groupId)
                    .map(response =>
                        CreateSuccess(
                            response.note,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateNoteEpic = (action$): Observable<INoteValidateSuccessAction | INoteValidateFailureAction> => {
        return action$
            .ofType(ACTION_NOTE_VALIDATE)
            .mergeMap((action: INoteValidateAction) => {
                return notesApi
                    .validateNote(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.note, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }



